<!-- TODO: get rid of this component -->
<template>
    <div class="well-score-metrics rounded">
        <div v-if="size === 'tooltip'" class="justify-between">
            <kid-score
                option="tooltip-option"
                :well="well"
                :color-background="false"
                :current-well-time-hours="currentWellTimeHours"
                class="pl-2"
            />
            <div class="flex-column ml-2 border-left-white pl-2">
                <span class="text-light-1">{{ $translate('blast') }}</span>
                <span class="text-size-13 text-bold">{{ formatScore(blastScore) }}</span>
            </div>
        </div>

        <div v-if="size === 'compare-well-small-card'">
            <span
                v-b-tooltip.hover
                class="teardrop reversed-x value text-size-7 text-bold px-1 text-dark"
                :class="kidScoreColor"
                :title="$translate('the_chance_for_a_successful_implantation')"
            >
                {{ formattedKidScore }}
            </span>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import UIUtils from '../../../business/utils/UIUtils'
import KidScore from '../score-metrics/KidScore'

const MAX_WELL_TIME_HOURS = 139.0

export default {
    name: 'WellScoreMetrics',
    components: { KidScore },
    props: {
        well: {
            type: Object,
            required: true
        },
        size: {
            type: String,
            default: 'small'
        },
        colorBackground: {
            type: Boolean,
            default: true
        },
        onlyBackgroundHighScore: {
            type: Boolean,
            default: false
        },
        currentWellTimeHours: {
            type: Number,
            default: null
        }
    },
    computed: {
        ...mapState({
            selectedTenant: state => state.common.selectedTenant
        }),
        inferenceData() {
            return this.well.inferenceData
        },
        isByCurrentHour() {
            return !!this.currentWellTimeHours
        },
        currentHourEven() {
            if (this.isByCurrentHour) {
                const hours =
                    this.currentWellTimeHours <= MAX_WELL_TIME_HOURS
                        ? this.currentWellTimeHours
                        : MAX_WELL_TIME_HOURS

                return 2 * Math.ceil(hours / 2)
            }

            return null
        },
        kidScore() {
            if (!this.isByCurrentHour) {
                return this.inferenceData.kidScore
            }
            const { kidScoreOverTime } = this.inferenceData

            return kidScoreOverTime && kidScoreOverTime[this.currentHourEven]
        },
        blastScore() {
            if (!this.isByCurrentHour) {
                return this.inferenceData.blastScore
            }
            const { blastScoreOverTime } = this.inferenceData

            return blastScoreOverTime && blastScoreOverTime[this.currentHourEven]
        },
        formattedKidScore() {
            return this.formatScore(this.kidScore)
        },
        kidScoreColor() {
            return UIUtils.getKidScoreColor(
                this.selectedTenant,
                this.kidScore,
                this.colorBackground,
                this.onlyBackgroundHighScore
            )
        }
    },
    methods: {
        formatScore(score) {
            return UIUtils.formatScore(score) || this.$translate('na')
        }
    }
}
</script>

<style lang="scss" scoped>
.well-score-metrics {
    .teardrop {
        width: 100%;
        background-color: $dark;

        &.value {
            background-color: $dark-4;
            min-width: 3rem;
        }
    }
}
</style>
